<cc-apps-tool-bar
  *ngIf="app"
  (exportCsvVisibleColumns)="exportCsvVisibleColumns()"
  (exportCsvAllColumns)="exportCsvAllColumns()"
  (exportPDF)="exportPDF()"
  (downloadPDF)="downloadForms()"
  (exportRegisterOnly)="exportsRegisterOnly()"
  (exportPDFWithOriginalPhotos)="exportPDFWithOriginalPhotos()"
  (registerViewSetting)="onSetRegisterView()"
  (resetRegisterViewFilter)="resetRegisterViewFilter()"
  (deleteSelected)="onDeleteSelected()"
  [app]="app"
  [canAdd]="canAdd"
  [isRegisterView]="true"
  [exportingCSV]="exportingCSV"
  [exportingPDF]="exportingPDF"
  [downloadingPDF]="downloadingPDF"
  [selectedForms]="selectedForms"
  [registerViewFilterCount]="registerViewFilterCount"
>
</cc-apps-tool-bar>

<cc-register-view
  [selectedForms]="selectedForms"
  [selectAll]="selectAll"
  [filterCount]="registerViewFilterCount"
  [canAdd]="canAdd"
>
</cc-register-view>

<router-outlet></router-outlet>
